<template>
  <v-container>
    <v-tabs show-arrows dark slider-color="primary" v-model="tab">
      <v-tab> <v-icon left small>far fa-plus-square</v-icon>Ajout </v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-form ref="addForm" v-model="valid" @submit.prevent>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="addProduct.name"
                    label="Nom"
                    prepend-icon="local_offer"
                    :rules="[v => !!v || 'Un nom est requis']"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="addProduct.price"
                    label="Prix"
                    min="0"
                    type="number"
                    prepend-icon="attach_money"
                    :rules="[v => !!v || 'Un prix est requis']"
                  ></v-text-field>
                </v-col>
                <v-switch
                  label="Taxable"
                  class="mx-3"
                  v-model="addProduct.taxable"
                ></v-switch>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row justify="end" no-gutters>
              <v-btn
                color="primary"
                :disabled="!valid"
                @click="addNewProduct"
                :block="$vuetify.breakpoint.xsOnly"
                :large="$vuetify.breakpoint.smAndDown"
              >
                <v-icon left>add</v-icon>Ajouter
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-spacer class="my-3 py-1"></v-spacer>
    <v-card>
      <v-data-table
        :items="products"
        :headers="headers"
        :search="search"
        :loading="loading"
      >
        <template v-slot:item.taxable="{ item }">
          <v-checkbox
            v-model="item.taxable"
            readponly
            hide-details
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click="openEditProductDialog(item.id_produit)">
            <v-icon small>far fa-edit</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <product-update-dialog
      v-if="editProduct.dialog"
      :productId="editProduct.productId"
      :productName="editProduct.productName"
      :isOpen.sync="editProduct.dialog"
      @update="getProducts"
    ></product-update-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import ProductUpdateDialog from "./CustomerAccountProductUpdateDialog";
export default {
  name: "CustomerAccountProductIndex",
  components: { "product-update-dialog": ProductUpdateDialog },
  data() {
    return {
      tab: 0,
      valid: false,
      search: "",
      loading: "primary",
      products: [],
      editProduct: {
        productId: null,
        productName: null,
        dialog: false
      },
      addProduct: {
        dialog: false,
        name: null,
        price: null,
        taxable: null
      },
      updateProductPrice: {
        dialog: false,
        menu: false,
        price: null,
        date: null
      },
      deleteDate: {
        menu: false
      },
      headers: [
        { value: "nom", text: "Nom" },
        { value: "prix", text: "Prix Actuel" },
        { value: "taxable", text: "Taxable" },
        { value: "date_retrait", text: "Date retrait" },
        { value: "actions", text: "" }
      ]
    };
  },
  methods: {
    addNewProduct: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/list/" +
          this.$store.getters["getStoreId"] +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        const data = {
          nom: this.addProduct.name,
          prix: this.addProduct.price,
          taxable: this.addProduct.taxable,
          store: this.$store.getters["getStoreId"],
          organisation: this.$store.getters.getOrganisationId
        };
        axios
          .post(url, data, config)
          .then(() => {
            this.getProducts();
            this.$refs.addForm.reset();
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getProducts: function() {
      this.loading = true;
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/list/" +
          this.$store.getters["getStoreId"] +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.products = d.data;
            this.loading = false;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    openEditProductDialog(productId) {
      this.editProduct.productId = productId;
      this.editProduct.productName = this.products.find(
        p => p.id_produit === productId
      );
      this.editProduct.dialog = true;
    }
  },
  watch: {
    storeId: {
      handler: "getProducts",
      immediate: true
    }
  }
};
</script>

<style scoped>
.hover {
  cursor: pointer;
}
</style>
